import React from 'react';
import classNames from 'classnames';
import { LegendProps, MapLayerSetting } from '../../api/Contracts';
import List from '../../../../components/list/List';
import SubLayerSetting from './SubLayerSetting';
import { MapServiceLayerMetadata } from '../../api/useTopicMetadataQuery';

interface GroupLayerSettingProps {
  topicId: string;
  settings: MapLayerSetting[];
  metadata: Record<number, MapServiceLayerMetadata>;
  legend: Record<number, LegendProps[]>;
  visibleSublayerIdsAtScale: Record<number, boolean>;
  onExpand: (id: number) => void;
  onEnable: (id: number) => void;
  parentId?: number;
}

const GroupLayerSetting = ({
  topicId,
  settings,
  metadata,
  legend,
  visibleSublayerIdsAtScale,
  onExpand,
  onEnable,
  parentId = -1,
}: GroupLayerSettingProps) => {
  const layers = settings
    .filter(({ parentLayerId }) => parentLayerId === parentId)
    .sort((a, b) => a.order - b.order);

  return (
    <List
      ulClassName={classNames({ 'topic-sub-layer-list': parentId !== -1 })}
      items={layers}
      renderItem={(layer) => (
        <>
          <SubLayerSetting
            layer={layer}
            metadata={metadata[layer.id] ?? null}
            legend={legend[layer.id]}
            isVisibleAtScale={visibleSublayerIdsAtScale[layer.id]}
            onEnable={() => onEnable(layer.id)}
            onExpand={() => onExpand(layer.id)}
            isExpandable={settings.some((setting) =>
              layer.subLayerIds.includes(setting.id),
            )}
          />
          {layer.isGroupLayer && layer.isExpanded && (
            <GroupLayerSetting
              topicId={topicId}
              parentId={layer.id}
              settings={settings}
              metadata={metadata}
              legend={legend}
              onEnable={onEnable}
              onExpand={onExpand}
              visibleSublayerIdsAtScale={visibleSublayerIdsAtScale}
            />
          )}
        </>
      )}
    />
  );
};

export default GroupLayerSetting;
